import './notyf-DIw0RvBj.js';
import { S as SwiperExt } from './swiper-BAqQR4kf.js';
import { S as Swiper } from './swiper-core-B0IA3Ohb.js';
import { N as Navigation } from './navigation-gIhQEyYP.js';
import { A as A11y } from './a11y-BSOb6_-2.js';
import './create-element-if-not-defined-DJqdjQL6.js';

class FeaturedCollections extends SwiperExt {
  swiper = this.querySelector('.swiper');
  swiperButtonNext = this.querySelector('.swiper-button-next');
  swiperButtonPrev = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 2,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('featured-collections', FeaturedCollections);
